import styled, { css } from 'styled-components';
import { ChevronLeftRegular, ChevronRightRegular } from '@fluentui/react-icons';

export const FooterWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr max-content;
  grid-template-rows: auto;
  grid-template-areas: '. PagesNavigationSection';
  padding: 18px 32px;
  background: ${(props) => props.theme.mainBackgorund};
  border-top: 2px solid ${(props) => props.theme.selectedDateBackground};
  margin-top: 15px;
`;

export const PagesNavigationSection = styled.div`
  grid-area: PageButtons;
  display: grid;
  grid-template-columns: 1fr max-content 8px max-content 8px max-content 8px max-content 8px max-content;
  grid-template-rows: auto;
  grid-template-areas: '. leftArrow . currentPage . separator . totalPages . rightArrow';
  align-items: center;
`;

const Arrow = css`
  width: 20px;
  height: 20px;
  cursor: pointer;
  &.disableLeft,
  &.disableRight {
    pointer-events: none;
    color: ${(props) => props.theme.defaultButtonBorderColor};
  }
`;

export const LeftArrow = styled(ChevronLeftRegular)`
  grid-area: leftArrow;
  ${Arrow}
`;

export const RightArrow = styled(ChevronRightRegular)`
  grid-area: rightArrow;
  ${Arrow}
`;

const Content = css`
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
  color: ${(props) => props.theme.textMainColor};
`;

export const CurrentPage = styled.span`
  grid-area: currentPage;
  ${Content}
  width: 20px;
  text-align: end;
`;

export const Separator = styled.span`
  grid-area: separator;
  ${Content}
`;

export const TotalPages = styled.span`
  grid-area: totalPages;
  ${Content}
`;
